import React, { createContext, useState} from "react";
import PropTypes from 'prop-types';
export const LoadingContext = createContext();

export const LoadingProvider = ({ children }) => {
  const [loading1, setLoading1] = useState(false);
  return (
    <LoadingContext.Provider value={{ loading1, setLoading1 }}>
      {children}
    </LoadingContext.Provider>
  );
};
LoadingProvider.propTypes = {
    children: PropTypes.node.isRequired,
};